/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Directive, Input, OnInit, ViewContainerRef } from '@angular/core';
import { NavLink } from './nav-link';

@Directive({
  selector: '[ghNavLinkContent]',
})
export class NavLinkContentDirective implements OnInit {
  @Input('ghNavLinkContent') navLinkContent: NavLink;

  constructor(private viewContainerRef: ViewContainerRef) {

  }

  ngOnInit(): void {
    this.viewContainerRef.createEmbeddedView(this.navLinkContent.templateRef);
  }
}
